import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { FclLoginService } from 'src/app/services/fcllogin.service';
import { OktaAuthService } from '@okta/okta-angular';
import { NavService } from 'src/app/services/nav.service';
import { FscHomeResolved } from 'src/app/model/fsc.home.model';
import { Module, FscAuthorizedMenusResolver } from 'src/app/model/nav-item';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  optionSelected: string;
  userName = '';
  modules: string[];
  userModules: Module[] = [];
  showCustomerSelectedMsg = false;
  userNotAuthorized = false;
  userIsInactive = false;
  notValidUser = false;

  constructor(
    public router: Router,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private navService: NavService,
    public commonService: CommonService,
    private fclLoginService: FclLoginService,
    private oktaAuth: OktaAuthService,
    ) { }

    async ngOnInit() {
    this.navService.clearSelectedModule();

    await this.activatedRoute.data.subscribe((fscHomeResolve) => {
      
      const fscAuthorizedMenusResolver: FscAuthorizedMenusResolver = fscHomeResolve.homeServiceResolver;

      if (fscAuthorizedMenusResolver !== undefined && fscAuthorizedMenusResolver.error === null) {
        const resp = fscAuthorizedMenusResolver.fscAuthorizedMenusResponse;
        if (resp.approvalStatus === '2') {
          this.userIsInactive = true;
        }
        this.navService.setModulesInLocalStorage(resp);
        if (resp.errors) {
          const errors = resp.errors;
          for (const er of errors) {
            if (er.code === 'ERR-FUM-2008') {
              this.userNotAuthorized = true;
            }
          }
        }
        if (!this.userNotAuthorized && !this.userIsInactive) {
          this.navService.getLocalModules();
          this.navService.modules$.subscribe(res => {
            this.userModules = res;
          })
        } else {
          this.userModules = [];
        }
      }
    });


    if (this.fclLoginService.getUserType() === 'I' || this.fclLoginService.getUserType() === 'T') {
      this.userName = this.fclLoginService.getUser().userName;
    } else if (this.fclLoginService.getUserType() === 'E') {
      if (this.fclLoginService.getUser().lastName !== undefined ) {
        this.userName = this.fclLoginService.getUser().firstName + '  ' + this.fclLoginService.getUser().lastName;
      } else {
        this.userName = this.fclLoginService.getUser().firstName;
      }
    }
    this.fclLoginService.notValidUser$.subscribe(async (res) => {
      this.notValidUser = res;
    })
  }

  onOptionsSelected(menu: string, routeUrl: string) {
    this.navService.homeClicked = true;
    if (routeUrl !== undefined) {
      this.showCustomerSelectedMsg = false;
      if ((this.fclLoginService.getUserType() === 'I') && menu === 'Operations Management') {
        const selectedCustomer = this.navService.getSelectedCustomer();
        this.navService.setMenuName('Item Management');
        if (!selectedCustomer) {
          this.showCustomerSelectedMsg = true;         
          this.navService.selectedMenuId = '1GP2_P0_C0';
          this.navService.setMenuPermissions(this.navService.selectedMenuId);
          return;
        }
      }

      if ((this.fclLoginService.getUserType() === 'I') && menu === 'INVOICING') {
        const selectedCustomer = this.navService.getSelectedCustomer();
        if (!selectedCustomer) {
          this.showCustomerSelectedMsg = true;         
          this.navService.selectedMenuId = '6GP1_P0_C0';
          this.navService.setMenuPermissions(this.navService.selectedMenuId);
          return;
        }
      }

      this.navService.setSelectedModule(menu);
      this.commonService.headerMenuTitle = menu;

      if ((this.fclLoginService.getUserType() === 'E') && menu === 'Configuration') {
        this.navService.selectedMenuId = '3GP1_P4_C0';
        this.navService.setMenuPermissions('3GP1_P4_C0');
        this.navService.homeComponentClick(routeUrl);
        this.router.navigateByUrl('/vendorManagement');
        return;
      }

      if ((this.fclLoginService.getUserType() === 'I') && menu === 'Configuration') {
        this.navService.setMenuName('Customer Management');
      }

      this.navService.homeComponentClick(routeUrl);
      this.router.navigateByUrl(routeUrl);

    }
  }

  onClose(alertType) {
    if (alertType === 'showCustomerSelectedMsg') {
      this.showCustomerSelectedMsg = false;
    } else if (alertType === 'userNotAuthorized') {
      this.userNotAuthorized = false;
      this.logout();
    } else if (alertType === 'userIsInactive') {
      this.userIsInactive = false;
      this.logout();
    }
  }

  logout() {

    if (this.fclLoginService.getUserType() === 'I' || this.fclLoginService.getUserType() === 'T') {
      this.fclLoginService.user = undefined;
      this.fclLoginService.clearLocalStorage();
      setTimeout(() => {
        this.oktaAuth.logout('/');
      }, 200);
    } else if (this.fclLoginService.getUserType() === 'E') {
      this.fclLoginService.user = undefined;
      this.fclLoginService.isUserLoggedIn = false;
      this.fclLoginService.clearLocalStorage();
      setTimeout(() => {
        this.router.navigate(['/']);
      }, 200);
    }
  }
}
